import { useEffect, useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { InvoiceDocument } from "@/components/admin/InvoiceDocument";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Printer } from "lucide-react";

export default function CustomerInvoice() {
  const { id } = useParams();
  const { settings } = useSettings();
  const [inv, setInv] = useState(null);
  const [err, setErr] = useState("");
  const ref = useRef(null);
  useEffect(() => { api.get(`/account/invoices/${id}`).then(({ data }) => setInv(data)).catch(() => setErr("Invoice not found")); }, [id]);
  return (
    <div className="space-y-4" data-testid="customer-invoice">
      <div className="flex items-center justify-between"><Link to="/account"><Button variant="ghost" className="rounded-full"><ArrowLeft className="h-4 w-4 mr-1" /> My Bookings</Button></Link>{inv && <Button className="rounded-full" onClick={() => window.print()}><Printer className="h-4 w-4 mr-1" /> Print / Save PDF</Button>}</div>
      {err && <p className="text-muted-foreground">{err}</p>}
      {inv && <div className="overflow-x-auto rounded-2xl border bg-white p-2"><InvoiceDocument ref={ref} inv={inv} settings={settings} /></div>}
    </div>
  );
}
